/* import __COLOCATED_TEMPLATE__ from './parent-folder-link.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */

import type Folder from 'embercom/models/content-service/folder';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';

interface Signature {
  Args: {
    folder: Folder;
    showIcon?: boolean;
    truncateShort?: boolean;
  };
}

export default class ParentFolderLink extends Component<Signature> {
  @service declare router: RouterService;

  /**
   * Determines the appropriate route based on the current context.
   * If we're in the automation/fin-ai-agent/content context, use that route.
   * Otherwise, default to the knowledge-hub route.
   */
  get folderRoute(): string {
    let currentRouteName = this.router.currentRouteName;

    if (currentRouteName?.startsWith('apps.app.automation.fin-ai-agent.content')) {
      return 'apps.app.automation.fin-ai-agent.content-folder';
    }

    return 'apps.app.knowledge-hub.folder';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::Folders::ParentFolderLink': typeof ParentFolderLink;
  }
}
